import { axiosInstance } from "./apiConfig"

export const apiGetAllStores = async (language = 'en') => {
    let stores = [];
    let currentPage = 1;
    let done = false;
    try {
        while (!done) {
            const { data } = await axiosInstance.get(`store/?language=${language}&page=${currentPage}`);
            stores.push(...data.data);
            if (data.pageNumber === data.totalPages) {
                done = true;
            } else {
                currentPage += 1;
            }
        }
        return stores;
    } catch (error) {
        console.log(error);
    }
}


// WEBPACK FOOTER //
// ./src/api/apiGetAllStores.js